var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"single-practice",class:{
    done: _vm.done,
    'reduced-opacity': _vm.reducedOpacity,
    'not-displayed': !_vm.displayed,
    focus: _vm.focus
  },on:{"click":_vm.click}})}
var staticRenderFns = []

export { render, staticRenderFns }